import classNames from "classnames";
import { inject } from "mobx-react";
import React, { useMemo } from "react";
import { Store } from "../../../../client/stores";
import { LinkedItemRecordFragment, PublishRecordFragment } from "../../../core/generated/webapi.g";
import { reverseRoute } from "../../../core/lib/route";
import { MagicLink } from "../../../core/ui";
import { getCoastLinks } from "../lib";
import "./CoastLinkedItems.style.scss";

interface CoastLinkedGuestsProps {
    item: PublishRecordFragment;
    titleOnSameLine: boolean;
    separator?: string;
    store?: Store;
}

interface CoastLinkedGuestItemProps {
    guest: LinkedItemRecordFragment;
    store?: Store;
}

export const CoastLinkedGuestItem = inject("store")(({ store, guest }: CoastLinkedGuestItemProps) => {
    if (!store) {
        return null;
    }

    const guestUrl = reverseRoute(store.site, "guests_detail", { slug: guest.slug }) || "#";

    return (
        <MagicLink to={guestUrl} context={guest.slug}>
            {guest.summary.title}
        </MagicLink>
    );
});

export const CoastLinkedGuests = ({ item, titleOnSameLine, separator = ", " }: CoastLinkedGuestsProps) => {
    const guests = useMemo(() => getCoastLinks(item, "guests"), [item]);

    if (!guests) {
        return null;
    }

    const className = classNames("coast-linked-guests coast-linked-items", { "title-on-same-line": titleOnSameLine });

    return (
        <p className={className}>
            <span className="linked-header">Guests{titleOnSameLine ? ":" : ""}</span>
            <span className="linked-value">
                {guests.map((guest, idx) => (
                    <React.Fragment key={idx}>
                        <CoastLinkedGuestItem guest={guest} />
                        {idx < guests.length - 1 ? <span>{separator}</span> : null}
                    </React.Fragment>
                ))}
            </span>
        </p>
    );
};
